import React, { Component } from 'react';

class SubPageHeader extends Component {
    render() {
        return (
            <div className="details-banner">
              <div className="banner-back-button"
                   onClick={this.props.onClickBack}
                >BACK</div>
              <div className="banner-heading">{this.props.headerText}</div>
            </div>);
    }
}

export default SubPageHeader;

